import React, { useState } from "react";
import { Container, Row, Col, Button, Modal, Form } from "react-bootstrap";
import "./hero.css";
import { Youtube } from "react-bootstrap-icons";

function HeroSection() {

  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    treatment: "",
    date: ""
  });

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL = "https://script.google.com/macros/s/AKfycbxQzpZpKCzBeBuAju8jsOCXFuThomZFdh8-Yx_IELE1omgw23KXNteOrt7qVSubU3hmqw/exec";

    try {
      await fetch(scriptURL, {
        method: "POST",
        body: JSON.stringify(formData)
      });

      alert("Appointment Booked Successfully!");

      setShowModal(false);

      setFormData({
        name: "",
        phone: "",
        treatment: "",
        date: ""
      });

    } catch (error) {
      alert("Error submitting form");
    }
  };

  return (
    <section className="hero-section d-flex">
      <Container fluid className="hero-container">
        <Row>

          {/* LEFT TEXT */}
          <Col md={6} className="text-center text-md-start pt-5 ps-5">

            <span className="hero-speacial text-uppercase">
              Best Cosmetologist in <strong>Pimpri Chinchwad</strong>
            </span>

            <p className="fw-bold slogun">
              START YOUR JOURNEY TO FLAWLESS BEAUTY
            </p>

            <span className="lh-lg hero-p">
              Expert solutions for every skin concern,<br/>
              transformative results for every patient.
            </span>

            <Container>
              <Row className="pt-5">

                <Col className="text-center hero-speacial">
                  <span className="fw-bold golden display-3">3+</span>
                  <br/>YEARS EXPERIENCE
                </Col>

                <Col className="text-center hero-speacial">
                  <span className="fw-bold golden display-3">2K+</span>
                  <br/>SATISFIED PATIENTS
                </Col>

                <Col className="text-center hero-speacial">
                  <span className="fw-bold golden display-3">14+</span>
                  <br/>ADVANCE TREATMENTS
                </Col>

              </Row>

              <Container className="appointment-container">
                <Row className="align-items-center justify-content-center hero-btn-row">

                  <Col xs="auto">
                    <Button
                      size="lg"
                      className="appointment-btn fw-bold shadow-lg"
                      onClick={handleShow}
                    >
                      Book Appointment
                    </Button>
                  </Col>

                  <Col xs="auto">
                    <a
                      href="https://www.youtube.com/@truptihambire5017"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button
                        variant="outline-light"
                        size="lg"
                        className="rounded-circle shadow-lg play-btn"
                      >
                        <Youtube size={30} className="text-danger" />
                      </Button>
                    </a>
                  </Col>

                </Row>
              </Container>

            </Container>
          </Col>

          {/* RIGHT IMAGE */}
          <Col md={6} className="right-img"></Col>

        </Row>
      </Container>

      {/* MODAL FORM */}

      <Modal show={showModal} onHide={handleClose} centered>

        <Modal.Header closeButton>
          <Modal.Title>Book Appointment</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <Form onSubmit={handleSubmit}>

            <Form.Group className="mb-3">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="tel"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Treatment</Form.Label>
              <Form.Select
                name="treatment"
                value={formData.treatment}
                onChange={handleChange}
              >
                <option>Select Treatment</option>
                <option>Skin Treatment</option>
                <option>Hair Treatment</option>
                <option>Laser Treatment</option>
                <option>Acne Treatment</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button type="submit" variant="dark" className="w-100">
              Book Appointment
            </Button>

          </Form>

        </Modal.Body>

      </Modal>

    </section>
  );
}

export default HeroSection;